export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
export const STATIC_BASE_URL = process.env.REACT_APP_STATIC_URL || API_BASE_URL;
